import { removeStartingSlash, getMdHeadingId, isHashLink } from '..';
import { isRelativeUrl } from '../transformToWixDocsUrlMapping';
import { toUrlFormat } from '../../treeVisitors';
import { replaceMdLinksSpaces } from '../../../Store/Utils/transformRelativeMdLinks';
import { isSubTreeKey } from '../../../client/components/NavigationMenu/utils';

export const isRelativeLinkToMdFile = (link) => {
  const isLinkIncludesHash = link.includes('#');
  const [withoutHashPart] = isLinkIncludesHash
    ? link.split('#')
    : link.split('"'); // in case of link with title, e.g: [Link to something awesome](../my-guide.md "Check out my guide")

  return (
    isHashLink(link) ||
    (isRelativeUrl(withoutHashPart) && withoutHashPart.trim().endsWith('.md'))
  );
};

export const getLinkParts = (link) => {
  const linkKeys = link.split('/');
  const urlFormat = linkKeys.pop();
  const prefix = linkKeys.join('/');
  return { urlFormat, prefix };
};

const getHashPartOfRelativeLink = (hash, link) => {
  const { prefix, urlFormat } = getLinkParts(link);
  return hash
    ? `#${getMdHeadingId(prefix, urlFormat)}_${toUrlFormat(hash)}`
    : '';
};

const extractUrlAndHash = (_url) => {
  const [urlWithoutHash, hash] = replaceMdLinksSpaces(_url).split('#');
  const isGuidePathWithTag = urlWithoutHash.includes('::');
  const url = isGuidePathWithTag
    ? urlWithoutHash.replace(/\.md$/, '')
    : urlWithoutHash;

  return { url, hash };
};
export const getRelativeMdLink = (_url, store) => {
  const { url, hash } = extractUrlAndHash(_url);

  const getGuideByGuidePath = (tree = {}) => {
    let relevantGuide;
    for (const key in tree) {
      if (isSubTreeKey(key)) {
        const guide = tree[key]?.data?.relatedGuides?.find(
          (_guide) => _guide?.id === url || _guide?.path === url
        );
        relevantGuide = guide || getGuideByGuidePath(tree[key]);
        if (relevantGuide) {
          break;
        }
      }
    }
    return relevantGuide;
  };

  const guide = getGuideByGuidePath(store.getFullTree());
  if (guide) {
    const hashPart = getHashPartOfRelativeLink(
      hash,
      removeStartingSlash(guide.link)
    );
    return `${guide.link}${hashPart}`;
  }
};
